import { HiStar } from "react-icons/hi";
import { reviews } from "../../util/Constants";

interface Props {
    className?: string;
}

function getInitials(name: string) {
    return name
        .split(" ")
        .map((part) => part[0])
        .join("")
        .slice(0, 2)
        .toUpperCase();
}

export default function Review({ className = "" }: Props) {
    return (
        <section className={`${className}`}>
            <div className="z-10 mx-auto flex max-w-7xl flex-col">
                <div className="mb-5 flex items-center gap-3">
                    <div className="h-px w-12 bg-web-primary" />
                    <span className="text-xs font-medium uppercase tracking-wider text-web-primary">
                        Trusted by builders
                    </span>
                </div>

                <h2 className="max-w-5xl text-4xl font-bold leading-tight md:text-5xl">
                    Loved by teams who ship messages that matter.
                </h2>


                <div className="mt-12 grid grid-cols-1 gap-6 sm:grid-cols-2 lg:grid-cols-3">
                    {reviews.map((item) => (
                        <div
                            key={item.id}
                            className="flex flex-col gap-4 rounded-[20px] border border-[#080A0D]/[0.12] bg-white/70 p-7 backdrop-blur-[6px]"
                        >
                            <div className="flex items-center gap-0.5">
                                {Array.from({ length: 5 }).map((_, i) => (
                                    <HiStar
                                        key={i}
                                        size={16}
                                        className={
                                            i < item.rating
                                                ? "text-web-primary"
                                                : "text-black/10"
                                        }
                                    />
                                ))}
                            </div>

                            <p className="text-sm leading-6 text-text-secondary">
                                "{item.review}"
                            </p>

                            <div className="mt-2 flex items-center gap-3">
                                <div className="flex h-11 w-11 shrink-0 items-center justify-center rounded-full bg-web-primary text-sm font-semibold text-white">
                                    {getInitials(item.name)}
                                </div>
                                <div>
                                    <p className="text-sm font-semibold text-black">
                                        {item.name}
                                    </p>
                                    <p className="text-xs text-text-secondary">
                                        {item.role}, {item.company}
                                    </p>
                                </div>
                            </div>
                        </div>
                    ))}
                </div>
            </div>
        </section>
    );
}